import { IAppState } from '../../../AppModulesWrapper';

import { selectIsInsufficientFunds } from '../checkoutInfo';
import { selectCanPayByCard } from '../user';
import { selectIsPublishToHiddenBase } from './selectIsPublishToHiddenBase';

export const selectShouldPayByCard = (state: IAppState): boolean => {
  const canPayByCard = selectCanPayByCard(state);
  const isInHiddenBase = selectIsPublishToHiddenBase(state);
  const isInsufficientFunds = selectIsInsufficientFunds(state);

  return !isInHiddenBase && canPayByCard && isInsufficientFunds;
};
